'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';

/**
 * Client-side component to track login state for analytics/debugging
 * - No longer handles redirects - server-side redirects handle routing
 * - Server-side redirects in /dashboard and /admin pages are more reliable
 * - This prevents redirect loops and flashing
 */
export default function OnboardingRedirect() {
  const { user } = useUser();

  // Track login state for analytics/debugging only
  // No redirects - let server-side handle routing
  useEffect(() => {
    if (user && typeof window !== 'undefined') {
      // Track when user logs in (for analytics/debugging)
      const wasLoggedOut = sessionStorage.getItem('clerkWasLoggedOut') === 'true';
      if (wasLoggedOut) {
        sessionStorage.setItem('clerkJustLoggedIn', 'true');
        sessionStorage.removeItem('clerkWasLoggedOut');
      }
    } else if (!user && typeof window !== 'undefined') {
      // Track when user logs out
      sessionStorage.setItem('clerkWasLoggedOut', 'true');
    }
  }, [user]);

  return null; // This component doesn't render anything
}

